import React from 'react';
import './CellBox.scss';

import { TrendTag } from '../../../trend-tag/TrendTag';

interface CellBoxProps {
  value: number;
  trend: string | number;
  suffix: string;
  tooltipId: string;
}

export const CellBox: React.FC<CellBoxProps> = ({ value, trend, suffix, tooltipId }) => {
  return (
    <div className="cell-box">
      <span>{value + suffix}</span>
      {trend !== 0 && <TrendTag trendValue={trend} suffix={suffix} size="SM" tooltipId={tooltipId} />}
    </div>
  );
};
